// Comprehensive manufacturer color database from major building material providers
// Total: 215+ colors across 5 major building material brands
// Source: Matching facadeai color-picker implementation

// RAL Classic - European standard color system (50 colors)
export const ralClassicColors = [
  // Whites & Creams (RAL 9xxx)
  { code: 'RAL 9016', name: 'Traffic White', hex: '#F7FBF5', rgb: 'rgba(241, 240, 234, 1)' },
  { code: 'RAL 9010', name: 'Pure White', hex: '#F7F9EF', rgb: 'rgba(241, 236, 225, 1)' },
  { code: 'RAL 9001', name: 'Cream', hex: '#EFEBDC', rgb: 'rgba(233, 224, 210, 1)' },
  { code: 'RAL 9002', name: 'Grey White', hex: '#DDDED4', rgb: 'rgba(215, 213, 203, 1)' },
  { code: 'RAL 9018', name: 'Papyrus White', hex: '#CFD3CD', rgb: 'rgba(200, 203, 196, 1)' },
  
  // Greys (RAL 7xxx)
  { code: 'RAL 7001', name: 'Silver Grey', hex: '#8F999F', rgb: 'rgba(142, 150, 157, 1)' },
  { code: 'RAL 7004', name: 'Signal Grey', hex: '#9EA0A1', rgb: 'rgba(155, 155, 155, 1)' },
  { code: 'RAL 7016', name: 'Anthracite Grey', hex: '#373F43', rgb: 'rgba(56, 62, 66, 1)' },
  { code: 'RAL 7021', name: 'Black Grey', hex: '#2E3234', rgb: 'rgba(48, 50, 52, 1)' },
  { code: 'RAL 7024', name: 'Graphite Grey', hex: '#474A50', rgb: 'rgba(70, 73, 79, 1)' },
  { code: 'RAL 7035', name: 'Light Grey', hex: '#CBD0CC', rgb: 'rgba(197, 199, 196, 1)' },
  { code: 'RAL 7036', name: 'Platinum Grey', hex: '#9A9697', rgb: 'rgba(151, 147, 146, 1)' },
  { code: 'RAL 7037', name: 'Dusty Grey', hex: '#7C7F7E', rgb: 'rgba(122, 123, 122, 1)' },
  { code: 'RAL 7039', name: 'Quartz Grey', hex: '#6B695F', rgb: 'rgba(106, 102, 94, 1)' },
  { code: 'RAL 7040', name: 'Window Grey', hex: '#9DA3A6', rgb: 'rgba(152, 158, 161, 1)' },
  
  // Blacks (RAL 9xxx)
  { code: 'RAL 9005', name: 'Jet Black', hex: '#0A0A0D', rgb: 'rgba(14, 14, 16, 1)' },
  { code: 'RAL 9011', name: 'Graphite Black', hex: '#1C1C1C', rgb: 'rgba(39, 41, 43, 1)' },
  
  // Browns (RAL 8xxx)
  { code: 'RAL 8001', name: 'Ochre Brown', hex: '#9C6B30', rgb: 'rgba(153, 99, 43, 1)' },
  { code: 'RAL 8003', name: 'Clay Brown', hex: '#80542F', rgb: 'rgba(124, 75, 39, 1)' },
  { code: 'RAL 8004', name: 'Copper Brown', hex: '#8F4E35', rgb: 'rgba(138, 73, 49, 1)' },
  { code: 'RAL 8007', name: 'Fawn Brown', hex: '#6F4A2F', rgb: 'rgba(109, 70, 43, 1)' },
  { code: 'RAL 8008', name: 'Olive Brown', hex: '#6F4F28', rgb: 'rgba(111, 74, 37, 1)' },
  { code: 'RAL 8011', name: 'Nut Brown', hex: '#5A3A29', rgb: 'rgba(88, 56, 39, 1)' },
  { code: 'RAL 8014', name: 'Sepia Brown', hex: '#49392D', rgb: 'rgba(72, 53, 38, 1)' },
  { code: 'RAL 8017', name: 'Chocolate Brown', hex: '#44322D', rgb: 'rgba(67, 47, 41, 1)' },
  { code: 'RAL 8019', name: 'Grey Brown', hex: '#3F3A3A', rgb: 'rgba(61, 54, 53, 1)' },
  
  // Beiges & Tans (RAL 1xxx)
  { code: 'RAL 1001', name: 'Beige', hex: '#D0B084', rgb: 'rgba(208, 176, 132, 1)' },
  { code: 'RAL 1002', name: 'Sand Yellow', hex: '#D2AA6D', rgb: 'rgba(210, 170, 109, 1)' },
  { code: 'RAL 1013', name: 'Oyster White', hex: '#E3D9C6', rgb: 'rgba(227, 217, 198, 1)' },
  { code: 'RAL 1014', name: 'Ivory', hex: '#DDC49A', rgb: 'rgba(221, 196, 154, 1)' },
  { code: 'RAL 1015', name: 'Light Ivory', hex: '#E6D2B5', rgb: 'rgba(230, 210, 181, 1)' },
  { code: 'RAL 1019', name: 'Grey Beige', hex: '#A48F7A', rgb: 'rgba(164, 143, 122, 1)' },
  
  // Greens (RAL 6xxx)
  { code: 'RAL 6005', name: 'Moss Green', hex: '#0F4336', rgb: 'rgba(17, 66, 50, 1)' },
  { code: 'RAL 6009', name: 'Fir Green', hex: '#26392F', rgb: 'rgba(38, 57, 47, 1)' },
  { code: 'RAL 6020', name: 'Chrome Green', hex: '#354733', rgb: 'rgba(54, 66, 47, 1)' },
  
  // Blues (RAL 5xxx)
  { code: 'RAL 5008', name: 'Grey Blue', hex: '#313C48', rgb: 'rgba(45, 58, 68, 1)' },
  { code: 'RAL 5011', name: 'Steel Blue', hex: '#232C3F', rgb: 'rgba(30, 43, 61, 1)' },
  { code: 'RAL 5013', name: 'Cobalt Blue', hex: '#232D53', rgb: 'rgba(34, 48, 83, 1)' },
  
  // Reds (RAL 3xxx)
  { code: 'RAL 3000', name: 'Flame Red', hex: '#AB2524', rgb: 'rgba(164, 40, 33, 1)' },
  { code: 'RAL 3003', name: 'Ruby Red', hex: '#8D1D2C', rgb: 'rgba(132, 25, 34, 1)' },
  { code: 'RAL 3004', name: 'Purple Red', hex: '#701F29', rgb: 'rgba(105, 27, 35, 1)' },
  { code: 'RAL 3009', name: 'Oxide Red', hex: '#703731', rgb: 'rgba(102, 48, 41, 1)' },
  { code: 'RAL 3011', name: 'Brown Red', hex: '#7E292C', rgb: 'rgba(119, 36, 36, 1)' },
];

// Gentek Colors - Complete catalog (119 colors)
export const gentekColors = [
  { code: 'GEN-001', name: 'Aged Grey', hex: '#828282', rgb: 'rgba(130, 130, 130, 1)' },
  { code: 'GEN-002', name: 'Almond', hex: '#EADDCA', rgb: 'rgba(234, 221, 202, 1)' },
  { code: 'GEN-003', name: 'AluCopper', hex: '#B87333', rgb: 'rgba(184, 115, 51, 1)' },
  { code: 'GEN-004', name: 'Amber', hex: '#FFBF00', rgb: 'rgba(255, 191, 0, 1)' },
  { code: 'GEN-005', name: 'Antique Brown', hex: '#6E5541', rgb: 'rgba(110, 85, 65, 1)' },
  { code: 'GEN-006', name: 'Antique Ivory', hex: '#FAF0E6', rgb: 'rgba(250, 240, 230, 1)' },
  { code: 'GEN-007', name: 'Aspen Brown', hex: '#826450', rgb: 'rgba(130, 100, 80, 1)' },
  { code: 'GEN-008', name: 'Atlantic White', hex: '#F5F5F5', rgb: 'rgba(245, 245, 245, 1)' },
  { code: 'GEN-009', name: 'Barnboard Grey', hex: '#87827D', rgb: 'rgba(135, 130, 125, 1)' },
  { code: 'GEN-010', name: 'Barrel Oak', hex: '#B48C64', rgb: 'rgba(180, 140, 100, 1)' },
  { code: 'GEN-011', name: 'Beachwood Grey', hex: '#AAA596', rgb: 'rgba(170, 165, 150, 1)' },
  { code: 'GEN-012', name: 'Beige', hex: '#F5F5DC', rgb: 'rgba(245, 245, 220, 1)' },
  { code: 'GEN-013', name: 'Black', hex: '#1E1E1E', rgb: 'rgba(30, 30, 30, 1)' },
  { code: 'GEN-014', name: 'Blanco', hex: '#FFFFFF', rgb: 'rgba(255, 255, 255, 1)' },
  { code: 'GEN-015', name: 'Blue Spruce', hex: '#5F736E', rgb: 'rgba(95, 115, 110, 1)' },
  { code: 'GEN-016', name: 'Bright White', hex: '#FFFFFF', rgb: 'rgba(255, 255, 255, 1)' },
  { code: 'GEN-017', name: 'Brownstone', hex: '#7B665E', rgb: 'rgba(123, 102, 94, 1)' },
  { code: 'GEN-018', name: 'Burgundy', hex: '#800020', rgb: 'rgba(128, 0, 32, 1)' },
  { code: 'GEN-019', name: 'Cabernet Red', hex: '#5E2129', rgb: 'rgba(94, 33, 41, 1)' },
  { code: 'GEN-020', name: 'Canyon Clay', hex: '#AA7355', rgb: 'rgba(170, 115, 85, 1)' },
  { code: 'GEN-021', name: 'Cashmere', hex: '#D2C3B9', rgb: 'rgba(210, 195, 185, 1)' },
  { code: 'GEN-022', name: 'Cedarwood', hex: '#A07350', rgb: 'rgba(160, 115, 80, 1)' },
  { code: 'GEN-023', name: 'Chai Cedar', hex: '#C89664', rgb: 'rgba(200, 150, 100, 1)' },
  { code: 'GEN-024', name: 'Charred Black', hex: '#28282D', rgb: 'rgba(40, 40, 45, 1)' },
  { code: 'GEN-025', name: 'Chelsea Bluff', hex: '#8C8278', rgb: 'rgba(140, 130, 120, 1)' },
  { code: 'GEN-026', name: 'Chesapeake Gray', hex: '#808080', rgb: 'rgba(128, 128, 128, 1)' },
  { code: 'GEN-027', name: 'Chestnut', hex: '#954535', rgb: 'rgba(149, 69, 53, 1)' },
  { code: 'GEN-028', name: 'Chestnut Brown', hex: '#5F4538', rgb: 'rgba(95, 69, 56, 1)' },
  { code: 'GEN-029', name: 'Cinnamon Walnut', hex: '#825537', rgb: 'rgba(130, 85, 55, 1)' },
  { code: 'GEN-030', name: 'Coastal Blue', hex: '#5F738C', rgb: 'rgba(95, 115, 140, 1)' },
  { code: 'GEN-031', name: 'Commercial Brown', hex: '#5A4B41', rgb: 'rgba(90, 75, 65, 1)' },
  { code: 'GEN-032', name: 'Cream', hex: '#FFFDD0', rgb: 'rgba(255, 253, 208, 1)' },
  { code: 'GEN-033', name: 'Dark Cherry', hex: '#823732', rgb: 'rgba(130, 55, 50, 1)' },
  { code: 'GEN-034', name: 'Dark Drift', hex: '#696969', rgb: 'rgba(105, 105, 105, 1)' },
  { code: 'GEN-035', name: 'Dark Fir', hex: '#8C5A3C', rgb: 'rgba(140, 90, 60, 1)' },
  { code: 'GEN-036', name: 'Dark National Walnut', hex: '#503C28', rgb: 'rgba(80, 60, 40, 1)' },
  { code: 'GEN-037', name: 'Dark Walnut', hex: '#5A412D', rgb: 'rgba(90, 65, 45, 1)' },
  { code: 'GEN-038', name: 'Delray Sand', hex: '#BEB4A0', rgb: 'rgba(190, 180, 160, 1)' },
  { code: 'GEN-039', name: 'Desert', hex: '#B4A08C', rgb: 'rgba(180, 160, 140, 1)' },
  { code: 'GEN-040', name: 'Desert Clay', hex: '#AA8C78', rgb: 'rgba(170, 140, 120, 1)' },
  { code: 'GEN-041', name: 'Dover Gray', hex: '#BEBEBE', rgb: 'rgba(190, 190, 190, 1)' },
  { code: 'GEN-042', name: 'Espresso', hex: '#4B372D', rgb: 'rgba(75, 55, 45, 1)' },
  { code: 'GEN-043', name: 'Exotic Walnut', hex: '#6E5032', rgb: 'rgba(110, 80, 50, 1)' },
  { code: 'GEN-044', name: 'Flagstone', hex: '#787D82', rgb: 'rgba(120, 125, 130, 1)' },
  { code: 'GEN-045', name: 'Granite Grey', hex: '#666666', rgb: 'rgba(102, 102, 102, 1)' },
  { code: 'GEN-046', name: 'Graphite', hex: '#535353', rgb: 'rgba(83, 83, 83, 1)' },
  { code: 'GEN-047', name: 'Harbor Blue', hex: '#466482', rgb: 'rgba(70, 100, 130, 1)' },
  { code: 'GEN-048', name: 'Harvest Shade', hex: '#D2B48C', rgb: 'rgba(210, 180, 140, 1)' },
  { code: 'GEN-049', name: 'Heritage Grey', hex: '#8C8C91', rgb: 'rgba(140, 140, 145, 1)' },
  { code: 'GEN-050', name: 'Hudson Slate', hex: '#505A64', rgb: 'rgba(80, 90, 100, 1)' },
  { code: 'GEN-051', name: 'Ice White', hex: '#F0F8FF', rgb: 'rgba(240, 248, 255, 1)' },
  { code: 'GEN-052', name: 'Iron Ore', hex: '#3C4146', rgb: 'rgba(60, 65, 70, 1)' },
  { code: 'GEN-053', name: 'Ivy Green', hex: '#325032', rgb: 'rgba(50, 80, 50, 1)' },
  { code: 'GEN-054', name: 'Jet Black', hex: '#0A0A0A', rgb: 'rgba(10, 10, 10, 1)' },
  { code: 'GEN-055', name: 'Juniper Grove', hex: '#64735A', rgb: 'rgba(100, 115, 90, 1)' },
  { code: 'GEN-056', name: 'Light Cherry', hex: '#B45A3C', rgb: 'rgba(180, 90, 60, 1)' },
  { code: 'GEN-057', name: 'Light National Walnut', hex: '#966E50', rgb: 'rgba(150, 110, 80, 1)' },
  { code: 'GEN-058', name: 'Linen', hex: '#FAF0E6', rgb: 'rgba(250, 240, 230, 1)' },
  { code: 'GEN-059', name: 'Maize', hex: '#FFF5C8', rgb: 'rgba(255, 245, 200, 1)' },
  { code: 'GEN-060', name: 'Majestic Brick', hex: '#8C3C28', rgb: 'rgba(140, 60, 40, 1)' },
  { code: 'GEN-061', name: 'Malt', hex: '#DCBE8C', rgb: 'rgba(220, 190, 140, 1)' },
  { code: 'GEN-062', name: 'Marine Dusk', hex: '#465569', rgb: 'rgba(70, 85, 105, 1)' },
  { code: 'GEN-063', name: 'Meadow Fern', hex: '#6E8264', rgb: 'rgba(110, 130, 100, 1)' },
  { code: 'GEN-064', name: 'Metallic Gray', hex: '#A0A5AA', rgb: 'rgba(160, 165, 170, 1)' },
  { code: 'GEN-065', name: 'Metallic Silver', hex: '#C0C0C0', rgb: 'rgba(192, 192, 192, 1)' },
  { code: 'GEN-066', name: 'Midnight Surf', hex: '#283246', rgb: 'rgba(40, 50, 70, 1)' },
  { code: 'GEN-067', name: 'Misty Taupe', hex: '#B4AAA0', rgb: 'rgba(180, 170, 160, 1)' },
  { code: 'GEN-068', name: 'Monterey Sand', hex: '#D2BEA0', rgb: 'rgba(210, 190, 160, 1)' },
  { code: 'GEN-069', name: 'Moonlit Moss', hex: '#505F46', rgb: 'rgba(80, 95, 70, 1)' },
  { code: 'GEN-070', name: 'Musket Brown', hex: '#64503C', rgb: 'rgba(100, 80, 60, 1)' },
  { code: 'GEN-071', name: 'Natural White', hex: '#F5F5F0', rgb: 'rgba(245, 245, 240, 1)' },
  { code: 'GEN-072', name: 'Nordic White', hex: '#FAFAFA', rgb: 'rgba(250, 250, 250, 1)' },
  { code: 'GEN-073', name: 'Northern Ash', hex: '#5A5550', rgb: 'rgba(90, 85, 80, 1)' },
  { code: 'GEN-074', name: 'Nutmeg', hex: '#8C6446', rgb: 'rgba(140, 100, 70, 1)' },
  { code: 'GEN-075', name: 'Old World Blue', hex: '#5A6E82', rgb: 'rgba(90, 110, 130, 1)' },
  { code: 'GEN-076', name: 'Pearl', hex: '#F0EBE1', rgb: 'rgba(240, 235, 225, 1)' },
  { code: 'GEN-077', name: 'Pebble', hex: '#BEB9AF', rgb: 'rgba(190, 185, 175, 1)' },
  { code: 'GEN-078', name: 'Plum Creek', hex: '#64555F', rgb: 'rgba(100, 85, 95, 1)' },
  { code: 'GEN-079', name: 'Rainware White', hex: '#F5F5F5', rgb: 'rgba(245, 245, 245, 1)' },
  { code: 'GEN-080', name: 'Richmond Red', hex: '#823228', rgb: 'rgba(130, 50, 40, 1)' },
  { code: 'GEN-081', name: 'Ridge Moss', hex: '#78877D', rgb: 'rgba(120, 135, 125, 1)' },
  { code: 'GEN-082', name: 'Rockport Brown', hex: '#5A3C32', rgb: 'rgba(90, 60, 50, 1)' },
  { code: 'GEN-083', name: 'Rockwell Blue', hex: '#50647D', rgb: 'rgba(80, 100, 125, 1)' },
  { code: 'GEN-084', name: 'Rustic Slate', hex: '#464B50', rgb: 'rgba(70, 75, 80, 1)' },
  { code: 'GEN-085', name: 'Sable', hex: '#504137', rgb: 'rgba(80, 65, 55, 1)' },
  { code: 'GEN-086', name: 'Saddle Wood', hex: '#785A3C', rgb: 'rgba(120, 90, 60, 1)' },
  { code: 'GEN-087', name: 'Sage', hex: '#82917D', rgb: 'rgba(130, 145, 125, 1)' },
  { code: 'GEN-088', name: 'Sandalwood', hex: '#B4A082', rgb: 'rgba(180, 160, 130, 1)' },
  { code: 'GEN-089', name: 'Sand Dune', hex: '#DCD2BE', rgb: 'rgba(220, 210, 190, 1)' },
  { code: 'GEN-090', name: 'Sandstone', hex: '#E1D7C3', rgb: 'rgba(225, 215, 195, 1)' },
  { code: 'GEN-091', name: 'Seaside Grey', hex: '#A0AAAF', rgb: 'rgba(160, 170, 175, 1)' },
  { code: 'GEN-092', name: 'Sequoia', hex: '#8C5032', rgb: 'rgba(140, 80, 50, 1)' },
  { code: 'GEN-093', name: 'Silver', hex: '#C0C0C0', rgb: 'rgba(192, 192, 192, 1)' },
  { code: 'GEN-094', name: 'Slate', hex: '#708090', rgb: 'rgba(112, 128, 144, 1)' },
  { code: 'GEN-095', name: 'Smoked Black', hex: '#2D2D32', rgb: 'rgba(45, 45, 50, 1)' },
  { code: 'GEN-096', name: 'Smoked Timber', hex: '#5A5046', rgb: 'rgba(90, 80, 70, 1)' },
  { code: 'GEN-097', name: 'Snow White', hex: '#FFFFFF', rgb: 'rgba(255, 255, 255, 1)' },
  { code: 'GEN-098', name: 'Spanish Cedar', hex: '#A06446', rgb: 'rgba(160, 100, 70, 1)' },
  { code: 'GEN-099', name: 'Spanish Moss', hex: '#828C78', rgb: 'rgba(130, 140, 120, 1)' },
  { code: 'GEN-100', name: 'Sterling', hex: '#B4B4B9', rgb: 'rgba(180, 180, 185, 1)' },
  { code: 'GEN-101', name: 'Storm', hex: '#787D87', rgb: 'rgba(120, 125, 135, 1)' },
  { code: 'GEN-102', name: 'Storm Grey', hex: '#646973', rgb: 'rgba(100, 105, 115, 1)' },
  { code: 'GEN-103', name: 'Sunbleached Oak', hex: '#D2C8B4', rgb: 'rgba(210, 200, 180, 1)' },
  { code: 'GEN-104', name: 'Super Matt Modern Walnut', hex: '#503C32', rgb: 'rgba(80, 60, 50, 1)' },
  { code: 'GEN-105', name: 'Table Walnut', hex: '#825F41', rgb: 'rgba(130, 95, 65, 1)' },
  { code: 'GEN-106', name: 'Tan', hex: '#D2B48C', rgb: 'rgba(210, 180, 140, 1)' },
  { code: 'GEN-107', name: 'Taylor Red', hex: '#963C32', rgb: 'rgba(150, 60, 50, 1)' },
  { code: 'GEN-108', name: 'Terra Rosa', hex: '#A05A50', rgb: 'rgba(160, 90, 80, 1)' },
  { code: 'GEN-109', name: 'Thistle', hex: '#D8BFD8', rgb: 'rgba(216, 191, 216, 1)' },
  { code: 'GEN-110', name: 'Treated Cedar', hex: '#AA7850', rgb: 'rgba(170, 120, 80, 1)' },
  { code: 'GEN-111', name: 'Urban Grey', hex: '#96969B', rgb: 'rgba(150, 150, 155, 1)' },
  { code: 'GEN-112', name: 'Watermill Blue', hex: '#6482A0', rgb: 'rgba(100, 130, 160, 1)' },
  { code: 'GEN-113', name: 'Wedgewood Blue', hex: '#647D9B', rgb: 'rgba(100, 125, 155, 1)' },
  { code: 'GEN-114', name: 'Western Cedar', hex: '#B48250', rgb: 'rgba(180, 130, 80, 1)' },
  { code: 'GEN-115', name: 'White', hex: '#FFFFFF', rgb: 'rgba(255, 255, 255, 1)' },
  { code: 'GEN-116', name: 'White 701', hex: '#FAFAFA', rgb: 'rgba(250, 250, 250, 1)' },
  { code: 'GEN-117', name: 'Wicker', hex: '#D7C3AF', rgb: 'rgba(215, 195, 175, 1)' },
  { code: 'GEN-118', name: 'Willow', hex: '#96A08C', rgb: 'rgba(150, 160, 140, 1)' },
  { code: 'GEN-119', name: 'Windswept Smoke', hex: '#918C87', rgb: 'rgba(145, 140, 135, 1)' },
];

// Sherwin-Williams - Exterior Colors (17 colors)
export const sherwinWilliamsColors = [
  { code: 'SW 7006', name: 'Extra White', hex: '#F1F0EA', rgb: 'rgba(241, 240, 234, 1)' },
  { code: 'SW 7005', name: 'Pure White', hex: '#F0EDE0', rgb: 'rgba(240, 237, 224, 1)' },
  { code: 'SW 7012', name: 'Creamy', hex: '#F4EDD6', rgb: 'rgba(244, 237, 214, 1)' },
  { code: 'SW 7015', name: 'Repose Gray', hex: '#C7C9C3', rgb: 'rgba(199, 201, 195, 1)' },
  { code: 'SW 7043', name: 'Worldly Gray', hex: '#ABA89F', rgb: 'rgba(171, 168, 159, 1)' },
  { code: 'SW 7019', name: 'Gauntlet Gray', hex: '#918A85', rgb: 'rgba(145, 138, 133, 1)' },
  { code: 'SW 7067', name: 'Cityscape', hex: '#69676C', rgb: 'rgba(105, 103, 108, 1)' },
  { code: 'SW 7069', name: 'Iron Ore', hex: '#4C4F4E', rgb: 'rgba(76, 79, 78, 1)' },
  { code: 'SW 6244', name: 'Naval', hex: '#1F3A5F', rgb: 'rgba(31, 58, 95, 1)' },
  { code: 'SW 6258', name: 'Tricorn Black', hex: '#2F2F30', rgb: 'rgba(47, 47, 48, 1)' },
  { code: 'SW 2857', name: 'Alabaster', hex: '#EADED4', rgb: 'rgba(234, 222, 212, 1)' },
  { code: 'SW 6119', name: 'Antique White', hex: '#E3D9CA', rgb: 'rgba(227, 217, 202, 1)' },
  { code: 'SW 7036', name: 'Accessible Beige', hex: '#D6C8B5', rgb: 'rgba(214, 200, 181, 1)' },
  { code: 'SW 7522', name: 'Pavestone', hex: '#968C7E', rgb: 'rgba(150, 140, 126, 1)' },
  { code: 'SW 2951', name: 'Urbane Bronze', hex: '#5C5653', rgb: 'rgba(92, 86, 83, 1)' },
  { code: 'SW 6230', name: 'Rainstorm', hex: '#475E6B', rgb: 'rgba(71, 94, 107, 1)' },
];

// Benjamin Moore - Exterior Colors (15 colors)
export const benjaminMooreColors = [
  { code: 'BM OC-17', name: 'White Dove', hex: '#F4F1E8', rgb: 'rgba(244, 241, 232, 1)' },
  { code: 'BM OC-65', name: 'Chantilly Lace', hex: '#F7F5F1', rgb: 'rgba(247, 245, 241, 1)' },
  { code: 'BM OC-52', name: 'Gray Owl', hex: '#D5D7D1', rgb: 'rgba(213, 215, 209, 1)' },
  { code: 'BM HC-172', name: 'Revere Pewter', hex: '#D2CEC3', rgb: 'rgba(210, 206, 195, 1)' },
  { code: 'BM 1475', name: 'Stonington Gray', hex: '#C8CCCA', rgb: 'rgba(200, 204, 202, 1)' },
  { code: 'BM 2129-40', name: 'Kendall Charcoal', hex: '#6B6B6A', rgb: 'rgba(107, 107, 106, 1)' },
  { code: 'BM 2133-10', name: 'Black', hex: '#191918', rgb: 'rgba(25, 25, 24, 1)' },
  { code: 'BM 1024', name: 'Manchester Tan', hex: '#D6C7B4', rgb: 'rgba(214, 199, 180, 1)' },
  { code: 'BM HC-26', name: 'Monroe Bisque', hex: '#E6DACB', rgb: 'rgba(230, 218, 203, 1)' },
  { code: 'BM 977', name: 'Sandy Hook Gray', hex: '#B4A895', rgb: 'rgba(180, 168, 149, 1)' },
  { code: 'BM HC-144', name: 'Hale Navy', hex: '#3B4F5F', rgb: 'rgba(59, 79, 95, 1)' },
  { code: 'BM 2059-10', name: 'Forest Green', hex: '#2A3F2E', rgb: 'rgba(42, 63, 46, 1)' },
  { code: 'BM 1570', name: 'Aegean Teal', hex: '#3E5D67', rgb: 'rgba(62, 93, 103, 1)' },
  { code: 'BM HC-67', name: 'Texas Leather', hex: '#75563F', rgb: 'rgba(117, 86, 63, 1)' },
  { code: 'BM 2110-10', name: 'Espresso Bean', hex: '#3B2821', rgb: 'rgba(59, 40, 33, 1)' },
];

// James Hardie - Siding Colors (15 colors)
export const jamesHardieColors = [
  { code: 'JH-01', name: 'Arctic White', hex: '#F5F5F0', rgb: 'rgba(245, 245, 240, 1)' },
  { code: 'JH-02', name: 'Navajo Beige', hex: '#E0D1B7', rgb: 'rgba(224, 209, 183, 1)' },
  { code: 'JH-03', name: 'Monterey Taupe', hex: '#C4B39A', rgb: 'rgba(196, 179, 154, 1)' },
  { code: 'JH-04', name: 'Autumn Tan', hex: '#B29A7E', rgb: 'rgba(178, 154, 126, 1)' },
  { code: 'JH-05', name: 'Aged Pewter', hex: '#979A97', rgb: 'rgba(151, 154, 151, 1)' },
  { code: 'JH-06', name: 'Light Mist', hex: '#C9CCC7', rgb: 'rgba(201, 204, 199, 1)' },
  { code: 'JH-07', name: 'Cobble Stone', hex: '#8B8679', rgb: 'rgba(139, 134, 121, 1)' },
  { code: 'JH-08', name: 'Iron Gray', hex: '#5E5F5D', rgb: 'rgba(94, 95, 93, 1)' },
  { code: 'JH-09', name: 'Boothbay Blue', hex: '#4A6572', rgb: 'rgba(74, 101, 114, 1)' },
  { code: 'JH-10', name: 'Evening Blue', hex: '#2F4858', rgb: 'rgba(47, 72, 88, 1)' },
  { code: 'JH-11', name: 'Night Gray', hex: '#3F4344', rgb: 'rgba(63, 67, 68, 1)' },
  { code: 'JH-12', name: 'Woodland Cream', hex: '#F0E6D2', rgb: 'rgba(240, 230, 210, 1)' },
  { code: 'JH-13', name: 'Heathered Moss', hex: '#7A8471', rgb: 'rgba(122, 132, 113, 1)' },
  { code: 'JH-14', name: 'Timber Bark', hex: '#5A4A3A', rgb: 'rgba(90, 74, 58, 1)' },
  { code: 'JH-15', name: 'Mountain Sage', hex: '#97A18E', rgb: 'rgba(151, 161, 142, 1)' },
];

// All color providers organized by brand
export const colorProviders = {
  'ral-classic': {
    id: 'ral-classic',
    name: 'RAL Classic',
    description: 'European standard color system - Most popular for windows, doors, and facades',
    colors: ralClassicColors,
  },
  'gentek': {
    id: 'gentek',
    name: 'Gentek',
    description: 'Premium vinyl siding and trim colors - Popular in North America',
    colors: gentekColors,
  },
  'sherwin-williams': {
    id: 'sherwin-williams',
    name: 'Sherwin-Williams',
    description: 'Professional exterior paint colors - Trusted by contractors',
    colors: sherwinWilliamsColors,
  },
  'benjamin-moore': {
    id: 'benjamin-moore',
    name: 'Benjamin Moore',
    description: 'Premium paint colors for exterior applications',
    colors: benjaminMooreColors,
  },
  'james-hardie': {
    id: 'james-hardie',
    name: 'James Hardie',
    description: 'Fiber cement siding colors - Industry leading durability',
    colors: jamesHardieColors,
  }
};

// Create a flat list of all colors for easy searching
export const allManufacturerColors = Object.values(colorProviders).flatMap(provider =>
  provider.colors.map(color => ({
    ...color,
    manufacturer: provider.id,
    manufacturerName: provider.name,
    searchString: `${provider.name} ${color.name} ${color.code}`.toLowerCase()
  }))
);

// Helper function to search colors
export const searchColors = (query) => {
  if (!query) return allManufacturerColors;
  
  const searchTerm = query.toLowerCase();
  return allManufacturerColors.filter(color => 
    color.searchString.includes(searchTerm)
  );
};

// Helper function to get colors by manufacturer
export const getColorsByManufacturer = (manufacturerId) => {
  return colorProviders[manufacturerId]?.colors || [];
};

// Helper function to find closest color match
export const findClosestColor = (rgbString) => {
  // Parse RGB string to get components
  const match = rgbString.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
  if (!match) return null;
  
  const [, r, g, b] = match.map(Number);
  
  let closestColor = null;
  let minDistance = Infinity;
  
  allManufacturerColors.forEach(color => {
    const colorMatch = color.rgb.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (!colorMatch) return;
    
    const [, cr, cg, cb] = colorMatch.map(Number);
    
    // Calculate Euclidean distance in RGB space
    const distance = Math.sqrt(
      Math.pow(r - cr, 2) +
      Math.pow(g - cg, 2) +
      Math.pow(b - cb, 2)
    );
    
    if (distance < minDistance) {
      minDistance = distance;
      closestColor = color;
    }
  });
  
  return closestColor;
};

// Export manufacturer names for dropdown
export const manufacturerNames = Object.values(colorProviders).map(provider => ({
  value: provider.id,
  label: provider.name
}));

// Helper to get color by code (for AI integration)
export const getColorByCode = (code) => {
  return allManufacturerColors.find(color => 
    color.code.toLowerCase() === code.toLowerCase()
  );
};

// Helper to get color by name and manufacturer
export const getColorByNameAndManufacturer = (name, manufacturerId) => {
  const provider = colorProviders[manufacturerId];
  if (!provider) return null;
  
  return provider.colors.find(color => 
    color.name.toLowerCase() === name.toLowerCase()
  );
};
